// extracted by mini-css-extract-plugin
export default {"passwordFeedback":"password_passwordFeedback__8AqUX"};